<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full card-profile-information staff-info-card"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
      :headStyle="{ paddingRight: 0 }"
      style="height: 500px"
    >
      <template #title>
        <div class="card-custom-header">
          <div class="header-icon-box icon-general">
            <a-icon type="user" />
          </div>
          <div class="header-text-group">
            <div class="d-flex align-items-center">
              <h5 class="header-title font-web m-0 mr-8">General</h5>
              <div class="header-tags-inline">
                <a-tag class="mr-4 header-pill-tag font-web" color="blue">
                  {{ dataInfo[0].top_department }}
                </a-tag>
                <a-tag class="header-pill-tag font-web" color="cyan">
                  {{ dataInfo[0].user_type.name_eng }}
                </a-tag>
              </div>
            </div>
            <span class="header-subtitle font-web">ข้อมูลทั่วไปและบัญชีผู้ใช้</span>
          </div>
        </div>
      </template>
      <a-descriptions class="mb-10" title="" :column="1">
        <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            MUIC Account :
            <span class="text-dark">{{ dataInfo[0].muic_account }}</span>
          </p>
          <p class="font-web text-muted mt-5 mb-5 f-12">สำหรับเข้าใช้งาน</p>
          <p class="font-web text-muted mt-5 mb-0 f-12">
            <ul>
              <li>ระบบสารสนเทศภายใน ( IN HOUSE SYSTEM )</li>
              <li>@MUIC-WiFi</li>
              <li>ระบบ SKY , SKY+</li>
            </ul>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="Tel Office">
          {{ dataInfo[0].telephone }}
        </a-descriptions-item>
        <a-descriptions-item label="Email">
          {{ dataInfo[0].email }}
        </a-descriptions-item>
        <a-descriptions-item label="Mail Group">
          {{ dataInfo[0].groupmail }}
        </a-descriptions-item>
        <a-descriptions-item label="Gender">
          <span v-if="dataInfo[0].gender === '1'">Male</span>
          <span v-else-if="dataInfo[0].gender === '2'">Female</span>
          <span v-else>-</span>
        </a-descriptions-item>
        <a-descriptions-item label="Nationality">
          {{ dataInfo[0].nationality === "1" ? "Thai" : "Other" }}
        </a-descriptions-item>
        <a-descriptions-item label="Degree">
          {{ dataInfo[0].degree.name_eng }}
        </a-descriptions-item>
        
        
      </a-descriptions>
    </a-card>
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.staff-info-card {
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.07);
  }
}

.card-custom-header {
  display: flex;
  align-items: center;
  padding: 6px 0;
}

.header-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  margin-right: 12px;
  flex-shrink: 0;
}

.icon-general {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  color: #0284c7;
}

.header-text-group {
  display: flex;
  flex-direction: column;
}

.header-title {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.25;
}

.header-tags-inline {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
}

.header-pill-tag {
  border-radius: 10px;
  font-size: 10.5px;
  padding: 0 8px;
  line-height: 18px;
  height: 18px;
  border: none;
}

.header-subtitle {
  font-size: 11.5px;
  color: #8f9bb3;
  margin-top: 1px;
}

.f-18 {
  font-size: 18px;
}
.f-16 {
  font-size: 16px;
}
.f-12 {
  font-size: 12px;
  font-weight: 300;
}
</style>